/* ==========================================================================
   ICON — WORN BY CHAMPIONS
   Powers sections/icon_champions.liquid: arrows, and dots that page through
   the scroll-snap track. No slider library.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    // The theme editor fires shopify:section:load on top of the initial boot,
    // so without this guard the same node gets a second set of listeners.
    if (root.getAttribute('data-kwbc-ready') === 'true') return;
    var track = root.querySelector('[data-kwbc-track]');
    if (!track) return;
    root.setAttribute('data-kwbc-ready', 'true');

    var prev = root.querySelector('[data-kwbc-prev]');
    var next = root.querySelector('[data-kwbc-next]');
    var dotsWrap = root.querySelector('[data-kwbc-dots]');

    /** One card plus its gap — how far a single arrow press or dot moves. */
    function step() {
      var card = track.querySelector('.kwbc-card');
      if (!card) return track.clientWidth;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    /**
     * Pages come from the real scrollable range rather than a card count, so
     * the number adapts per breakpoint and the last stop always lands on the
     * last dot instead of leaving a dead one at the end.
     */
    function pages() {
      var one = step();
      if (!one) return 1;
      return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / one) + 1);
    }

    function buildDots() {
      if (!dotsWrap) return;
      var count = pages();
      if (count <= 1) { dotsWrap.innerHTML = ''; return; }
      if (dotsWrap.childElementCount === count) return;

      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'kwbc-dot';
          dot.setAttribute('aria-label', 'Slide ' + (index + 1));
          dot.addEventListener('click', function () {
            track.scrollTo({ left: index * step(), behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
        })(i);
      }
    }

    function update() {
      var one = step();
      var count = pages();
      var scrollable = track.scrollWidth - track.clientWidth;
      var atEnd = track.scrollLeft >= scrollable - 2;

      var index = one ? Math.round(track.scrollLeft / one) : 0;
      if (atEnd) index = count - 1;
      index = Math.min(count - 1, Math.max(0, index));

      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      // nothing to scroll — hide the controls rather than leave dead buttons
      var overflows = scrollable > 3;
      if (prev) { prev.hidden = !overflows; prev.disabled = track.scrollLeft <= 2; }
      if (next) { next.hidden = !overflows; next.disabled = atEnd; }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var frame;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }, { passive: true });

    function refresh() { buildDots(); update(); }
    root.__kwbcRefresh = refresh;

    // Portraits arrive after the first paint and change scrollWidth, and the
    // breakpoint changes how many cards fit, so re-measure on both.
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(refresh).observe(track);
    }
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    refresh();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-kwbc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
